export default function letters(name: string): string {
  let result = '';
  const nameTrimmed = name.trim();
  if (nameTrimmed.includes(' ')) {
    const parts = nameTrimmed.split(' ');
    result = `${parts[0][0]}${parts[1][0]}`;
  } else if (nameTrimmed.includes('.')) {
    const parts = nameTrimmed.split('.');
    result = `${parts[0][0]}${parts[1][0]}`;
  } else {
    result = `${nameTrimmed[0]}${nameTrimmed[1]}`;
  }
  return result.toUpperCase();
}
